//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/mesh/teleport/control.proto.
 */
export const file_dxos_mesh_teleport_control = /*@__PURE__*/ fileDesc("CiBkeG9zL21lc2gvdGVsZXBvcnQvY29udHJvbC5wcm90bxIaZHhvcy5tZXNoLnRlbGVwb3J0LmNvbnRyb2wiKAoYUmVnaXN0ZXJFeHRlbnNpb25SZXF1ZXN0EgwKBG5hbWUYASABKAkiUAoXQ29udHJvbEhlYXJ0YmVhdFJlcXVlc3QSNQoRcmVxdWVzdF90aW1lc3RhbXAYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIlEKGENvbnRyb2xIZWFydGJlYXRSZXNwb25zZRI1ChFyZXF1ZXN0X3RpbWVzdGFtcBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAy6wEKDkNvbnRyb2xTZXJ2aWNlEmEKEVJlZ2lzdGVyRXh0ZW5zaW9uEjQuZHhvcy5tZXNoLnRlbGVwb3J0LmNvbnRyb2wuUmVnaXN0ZXJFeHRlbnNpb25SZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5EnYKCUhlYXJ0YmVhdBIzLmR4b3MubWVzaC50ZWxlcG9ydC5jb250cm9sLkNvbnRyb2xIZWFydGJlYXRSZXF1ZXN0GjQuZHhvcy5tZXNoLnRlbGVwb3J0LmNvbnRyb2wuQ29udHJvbEhlYXJ0YmVhdFJlc3BvbnNlYgZwcm90bzM", [file_google_protobuf_empty, file_google_protobuf_timestamp]);
/**
 * Describes the message dxos.mesh.teleport.control.RegisterExtensionRequest.
 * Use `create(RegisterExtensionRequestSchema)` to create a new message.
 */
export const RegisterExtensionRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_control, 0);
/**
 * Describes the message dxos.mesh.teleport.control.ControlHeartbeatRequest.
 * Use `create(ControlHeartbeatRequestSchema)` to create a new message.
 */
export const ControlHeartbeatRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_control, 1);
/**
 * Describes the message dxos.mesh.teleport.control.ControlHeartbeatResponse.
 * Use `create(ControlHeartbeatResponseSchema)` to create a new message.
 */
export const ControlHeartbeatResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_control, 2);
/**
 * / Controls the lifycycle of the teleport session and its exentsions.
 *
 * @generated from service dxos.mesh.teleport.control.ControlService
 */
export const ControlService = /*@__PURE__*/ serviceDesc(file_dxos_mesh_teleport_control, 0);
//# sourceMappingURL=control_pb.js.map